<div class="loading-container">
  <div class="loading-top"></div>
  <div class="loading-bot">
    <div class="line shine l-237"></div>
    <div class="line shine l-188"></div>
    <div class="line shine l-154"></div>
    <div class="line shine l-142"></div>
    <div class="line shine l-157"></div>
    <div class="line shine l-142"></div>
    <div class="line shadow"></div>
    <div class="line shadow"></div>
    <div class="line shine l-154"></div>
    <div class="line shine l-237"></div>
  </div>
</div>